import { useRoot } from '../app/useRoot'

export function useOrderModel() {
  const { order } = useRoot()
  return order
}
